var map = {
	"./durable.png": 533,
	"./facebook.png": 2334,
	"./insta.png": 8861,
	"./medal.png": 5953,
	"./mesure.png": 8339,
	"./quality.png": 3955,
	"./youtube.png": 2843
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5977;